import { render } from "./boomerang.vue?vue&type=template&id=29039ee6&scoped=true"
const script = {}

import "./boomerang.vue?vue&type=style&index=0&id=29039ee6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29039ee6"]])

export default __exports__